import { APP_URL } from "../Utils/AppConstance";
export const genericFetchData = async (url, method, data) => {
  if (method == "POST") {
    const userCode = localStorage.getItem("user-code");
    data.userCode = userCode;
  }
  try {
    const response = await fetch(APP_URL + url, {
      method: method,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    // const responseData = await response.json();
    // const status = response.status;
    return response;
  } catch (error) {
    console.log("===🔥🔥🔥🔥error🔥🔥🔥🔥=======>", error); // Return a default status code (e.g., 500) for errors
  }
};

export const uploadDocuments = async (data) => {
  const headers = {
    Accept: "*/*",
    // "Content-Type": "multipart/form-data",
  };
  const userCode = localStorage.getItem("user-code");

  const formData = new FormData();
  data.documents.forEach((file) => {
    formData.append("documents", file);
  });
  formData.append("context", data.context);
  formData.append("category", data.category);
  formData.append("contextId", data.contextId);
  formData.append("userCode", userCode);

  const response = await fetch(`${APP_URL}/document/upload`, {
    method: "POST",
    headers: headers,
    body: formData,
  });

  return response;
};
